import { Box, Grid, Stack } from '@mantine/core';
import type { CellContext } from '@tanstack/table-core';

import type { DataTableFeatures } from '@apple/ui/data-table/features';
import type { DashboardCard } from '@apple/ui/shell/components/Dashboard';
import { Dashboard } from '@apple/ui/shell/components/Dashboard';

import { useUserAnnouncements } from '@apple/features/announcements/hooks/useUserAnnouncements';
import { UserAnnouncements } from '@apple/features/announcements-channel/components/UserAnnouncements';
import { OrdersPendingApprovalTable } from '@apple/features/order-channel/components/OrdersPendingApprovalTable';
import type { OrderApprovalListing } from '@apple/features/order-channel/models/approval';

type Props = {
	cards: DashboardCard[];
	renderOrderLink: (
		ctx: CellContext<DataTableFeatures, OrderApprovalListing, unknown>,
	) => React.ReactNode;
};

export function AdminDashboard({ cards, renderOrderLink }: Props) {
	const userAnnouncements = useUserAnnouncements();

	return (
		<Grid gap={{ base: 5, xs: 'md', md: 'xl', xl: 10 }}>
			<Grid.Col span={{ base: 12, lg: 6 }}>
				<Stack>
					<Dashboard cards={cards} py='sm' px='md' mx='xl' />
					{!userAnnouncements.isLoading &&
						!userAnnouncements.error &&
						userAnnouncements.data && (
							<Box py='sm' px='md' mx='xl'>
								<UserAnnouncements announcementList={userAnnouncements.data} />
							</Box>
						)}
				</Stack>
			</Grid.Col>
			<Grid.Col span={{ base: 12, lg: 6 }}>
				<OrdersPendingApprovalTable renderOrderLink={renderOrderLink} />
			</Grid.Col>
		</Grid>
	);
}
